import { useMemo, type FC, memo, useEffect, useState } from 'react';
import { frontRoyalStoreProvider } from 'FrontRoyalStore';
import { twMerge } from 'tailwind-merge';
import { type StorableImageProps } from './StorableImage.types';

export const StorableImage: FC<StorableImageProps> = memo(
    ({ src: _src, alt, cacheForever, fadeInOnLoad, className: _className }) => {
        const [src, setSrc] = useState<string>(() => _src);
        const [fetchedFromCache, setFetchedFromCache] = useState(() => false);

        const className = useMemo(
            () => twMerge(_className, fadeInOnLoad && 'animate-fade-in'),
            [_className, fadeInOnLoad],
        );

        useEffect(() => {
            if (!cacheForever || fetchedFromCache) return;

            frontRoyalStoreProvider
                .get()
                ?.getDataUrlIfStored(_src, cacheForever)
                .then(url => {
                    setSrc(url);
                    setFetchedFromCache(true);
                });
        }, [_src, cacheForever, fetchedFromCache]);

        return <img src={src} alt={alt} className={className} />;
    },
);
